type Tab = { id: string; label: string }

type TabsProps = {
  tabs: Tab[]
  active: string
  onChange: (id: string) => void
}

export const Tabs = ({ tabs, active, onChange }: TabsProps) => {
  return (
    <div className="border-b border-slate-200">
      <nav className="-mb-px flex flex-wrap gap-1" aria-label="Abas">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={`whitespace-nowrap border-b-2 px-4 py-2 text-sm font-medium transition ${
              active === tab.id
                ? "border-brand-600 text-brand-700"
                : "border-transparent text-slate-600 hover:border-slate-300 hover:text-slate-900"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  )
}
